<template>
  <div class="st-parallax">
    <div class="st-parallax-wrapper">
        <div class="parallax-content">
            <div class="parallax-background" v-if="attributes.value.photo" :style="{backgroundImage:`url(${getSource(attributes.value.photo.src)})`}"></div>
            <div class="parallax-background" v-else-if="attributes.value.video || attributes.value.video.poster">
                <video :src="getSourceOnce(attributes.value.video.src)" :poster="getPosterSource(attributes.value.video.poster)" loop autoplay playsinline muted></video>
            </div>
            <div class="parallax-content-wrapper">
                <h2 class="title" v-if="attributes.value.title">{{attributes.value.title}}</h2>
                <p class="description" v-if="attributes.value.description" v-markdown="attributes.value.description"></p>
            </div>
        </div>
    </div>
    <div class="st-parallax-caption" v-if="attributes.value.caption" v-markdown="attributes.value.caption"></div>
    
  </div>
</template>

<script>

export default {
    props: ['attributes'],
    computed: {
        isTabletWidth () {
            return window.innerWidth <= 768
        },
        hasDesktopSource () {
            const {hasdesktop} = this.attributes.value
            return !hasdesktop || hasdesktop !== 'false'
        }
    },
    methods: {
        getSource (value) {
            if (!value) return null
            const {isTabletWidth, hasDesktopSource} = this
            var path = value
            if (!isTabletWidth && hasDesktopSource) {
                var [name, ext] = value.split('.')
                path = name + '-desktop.' + ext
            }
            return require(`images/${path}`)
        },
        getPosterSource (value) {
            const {isTabletWidth, hasDesktopSource} = this
            let path = null
            if (value) {
                const [name, ext] = value.split('.')
                path = name + (!global.isMobile && this.hasDesktopSource ? '-desktop.' : '.') + ext
            }
            return path ? require(`videos/${path}`) : null
        },
        getSourceOnce (value) {
            if (value) {
                const [name, ext] = value.split('.')
                const path = name + (!global.isMobile && this.hasDesktopSource ? '-desktop.' : '.') + ext
                return require(`videos/${path}`)
            }
        }
    }
}
</script>

<style lang="scss">
.component.component-parallax {
    padding-left: 0;
    padding-right: 0;
}

.st-parallax {
    position: relative;
    .st-parallax-wrapper {
        position: relative;
        width: 100vw;
        height: 100vh;
        // @media (min-width: $d_normal) {
        //     max-width: calc(100vw - 320px);
        // }
    }
    .parallax-content {
        position: absolute;
        width: 100%;
        height: 100%;
        color: white;
        text-align: center;
        clip: rect(0,auto,auto,0);
        .parallax-background {
            position: fixed;
            display: block;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            will-change: transform;
            // z-index: -1;
            background-attachment: scroll;
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: cover;
            @media (min-width: $d_normal) {
                // max-width: calc(100% - 320px);
                // margin-left: $sidebar_width;
            }
            video {
                object-fit: cover;
                object-position: center center;
                width: 100%;
                height: 100vh;
            }
        }
        .parallax-content-wrapper {
            position: absolute;
            width: 100%;
            max-width: 700px;
            margin: 0 auto;
            padding: 10px;
            box-sizing: border-box;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                margin-bottom: 20px;
            }
            .description {
                color: white;
            }
        }
        
    }
    
    .st-parallax-caption {
        position: relative;
        max-width: 1200px;
        font-family: $font-CuratorRegular;
        font-size: 15px;
        line-height: 22px;
        color: #A5A5A5;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 10px $outerSpacingMobile 0;
        
        @include breakpoint($d_medium) {
            padding: 10px $outerSpacing 0;
        }

        strong {
            font-family: $font-CuratorBold;
        }
    }
}

</style>